/* Alba Stella - size advisor "Welke maat heb ik?" (owner P + Q; SIZE-ADVISOR-ALBA, 20 Oct 2026).
   Markup: snippet alba-pdp-i-sa (a [data-alba-sa] host with its JSON config), shown in the hero size modal of Livia, Marta,
   Matilde and in the "Maattabel" dialog of Agata and of the quick views. Loaded by the host's own img onerror (snippet), once per page.
   Privacy: everything is calculated here, in the browser. No storage (no cookies, localStorage, sessionStorage), no network
   call except the add to cart the customer asks for. The form lives in a shadow root, so its input/change/submit events
   never reach page-level listeners (e.g. analytics DOM-event capture) with the typed values.
   Logic (documented in /home/claude/demo/SIZE-ADVISOR-REPORT.md, tested in size-advisor-tests.md):
   1. Body estimate from height + weight (BMI), as natural-waist garment measurements of adult women:
        bottoms: taille = 80 + 2.5*(BMI-25) + 0.10*(cm-168);  heup = 103 + 2.1*(BMI-25) + 0.15*(cm-168)
        tops:    borst  = 95 + 2.2*(BMI-25) + 0.10*(cm-168);  onderborst = 78 + 1.9*(BMI-25) + 0.10*(cm-168)
      (typical error ±5-6 cm = about one size, hence the conservative rules below).
   2. Each measure → the first size whose upper limit it does not exceed (between two bands = the larger size).
      Body size = the largest of the measures (as the size table says). Usual EU size → the size of the table's
      "Confectiemaat" column. The advice is never below the LARGEST of all signals.
   3. Safety step: the body size goes up one when a measure that sets it is within 2 cm of that size's upper limit.
      Disagreement between usual size and body size is resolved by taking the larger one (= one step up from the smaller);
      no second step, which would make the advice non-monotonic (heavier → smaller) and 2 sizes over the usual size.
      Limit: when the usual size is known, never more than one size above it unless the body estimate itself is larger.
   4. Pasvorm "ruim" +1; "strak" never lowers the advice. Cap at the largest size; signals beyond the table → largest size
      + "neem contact op". Pijplengte (Livia): garment inseam closest to 0.44*cm + 1 (ties → longer). */
(function (root) {
  'use strict';

  var NEAR = 2;          // cm below a size's upper limit that counts as "borderline"
  var DASH = /[–-]/;     // ranges are written min–max

  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function range(s) {
    var p = String(s).split(DASH);
    var a = num(p[0]), b = num(p.length > 1 ? p[1] : p[0]);
    return [a, isNaN(b) ? a : b];
  }
  function normSize(s) { return String(s).replace(/ /g, '').toUpperCase().replace('XXL', '2XL'); }

  /* Chart rows of the product, in the product's own size order (sizes without a row are skipped). */
  function chart(cfg) {
    var rows = {};
    String(cfg.rows || '').split('|').forEach(function (r) {
      var c = r.split('~');
      if (c.length < 4) return;
      rows[normSize(c[0])] = { m: [range(c[1]), range(c[2])], eu: range(c[c.length - 1]) };
    });
    var out = [];
    (cfg.sizes || []).forEach(function (s) {
      var r = rows[normSize(s)];
      if (r) out.push({ size: s, m: r.m, eu: r.eu });
    });
    return out;
  }

  function estimate(kind, h, w) {
    var bmi = w / Math.pow(h / 100, 2), d = bmi - 25, dh = h - 168;
    var m = kind === 'tops'
      ? [95 + 2.2 * d + 0.10 * dh, 78 + 1.9 * d + 0.10 * dh]
      : [80 + 2.5 * d + 0.10 * dh, 103 + 2.1 * d + 0.15 * dh];
    return { bmi: Math.round(bmi * 10) / 10, m: m.map(function (v) { return Math.round(v * 10) / 10; }) };
  }

  function sizeFor(rows, k, v) {
    for (var i = 0; i < rows.length; i++) { if (v <= rows[i].m[k][1]) return i; }
    return rows.length; // beyond the table
  }
  function confFor(rows, c) {
    for (var i = 0; i < rows.length; i++) { if (c <= rows[i].eu[1]) return i; }
    return rows.length;
  }

  function lengthFor(lengths, h) {
    var target = 0.44 * h + 1, best = -1, bestD = Infinity;
    (lengths || []).forEach(function (val, i) {
      var m = String(val).match(/([0-9]+(?:[.,][0-9]+)?) ?cm/i);
      if (!m) return;
      var d = Math.abs(num(m[1]) - target);
      if (d < bestD - 1e-9 || (Math.abs(d - bestD) < 1e-9 && i > best)) { best = i; bestD = d; }
    });
    return best;
  }

  /* input: { h: cm, w: kg, conf: EU size number or null ("weet ik niet"), fit: 'strak' | 'normaal' | 'ruim' } */
  function recommend(cfg, input) {
    var rows = chart(cfg), n = rows.length;
    if (!n) return null;
    var e = estimate(cfg.kind, input.h, input.w);
    var mi = e.m.map(function (v, k) { return sizeFor(rows, k, v); });
    var body = Math.max.apply(null, mi);
    var ci = input.conf == null ? null : confFor(rows, input.conf);
    // Safety step on the body estimate: a measure within NEAR cm of its size's upper limit → one size up.
    var near = e.m.some(function (v, k) { return mi[k] === body && body < n && rows[body].m[k][1] - v <= NEAR; });
    var bodyAdv = body + (near ? 1 : 0);
    // The largest signal wins; when the two disagree, taking the larger IS the step up from the smaller one.
    var r = ci == null ? bodyAdv : Math.max(bodyAdv, ci);
    // Never more than one size above the usual size, unless the body estimate itself is larger.
    if (ci != null) r = Math.min(r, Math.max(body, ci + 1));
    var disagree = ci != null && ci !== body;
    if (input.fit === 'ruim') r += 1;
    var outside = body >= n || (ci != null && ci >= n);
    var capped = r > n - 1;
    var idx = Math.max(0, Math.min(r, n - 1));
    var name = function (i) { return i >= n ? '>' + rows[n - 1].size : rows[i].size; };
    return {
      index: idx, size: rows[idx].size, outside: outside, capped: capped, near: near, disagree: disagree,
      bmi: e.bmi, measures: e.m, measureSizes: mi.map(name), confSize: ci == null ? null : name(ci), bodySize: name(body),
      length: cfg.lengths && cfg.lengths.length ? lengthFor(cfg.lengths, input.h) : -1
    };
  }

  var core = { recommend: recommend, estimate: estimate, chart: chart, lengthFor: lengthFor };
  if (typeof module === 'object' && module.exports) { module.exports = core; return; }
  if (root.AlbaSA) { root.AlbaSA.scan(); return; }

  /* ------------------------------------------------------------------ UI ------------------------------------------------------------------ */
  var doc = root.document;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function qsa(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }

  var CSS = [
    ':host{display:block;margin:20px 0 4px;text-align:left;color:#242422;font-size:14px;line-height:21px}',
    '*{box-sizing:border-box}',
    '[hidden]{display:none !important}',
    '.card{border:1px solid #E5E2DD;border-radius:12px;background:#FAF9F7;padding:18px 18px 16px}',
    '.h{margin:0;font-size:16px;line-height:22px;font-weight:600;color:#242422}',
    '.lead{margin:4px 0 14px;font-size:14px;line-height:21px;color:#55534F}',
    '.grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}',
    '.f{min-width:0}',
    '.lab,legend{display:block;margin:0 0 6px;padding:0;font-size:13px;line-height:18px;font-weight:600;color:#34332F}',
    '.box{position:relative}',
    'input[type=text],select{display:block;width:100%;height:48px;margin:0;border:1px solid #CFCAC3;border-radius:8px;background:#fff;color:#242422;font:inherit;font-size:16px;line-height:20px}',
    'input[type=text]{padding:0 42px 0 14px}',
    '.unit{position:absolute;right:14px;top:50%;transform:translateY(-50%);font-size:14px;color:#6F6B66;pointer-events:none}',
    'select{padding:0 40px 0 14px;-webkit-appearance:none;appearance:none;cursor:pointer;background-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27M1 1.5l5 5 5-5%27 fill=%27none%27 stroke=%27%23242422%27 stroke-width=%271.6%27/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 14px center}',
    'input[type=text]:focus-visible,select:focus-visible{outline:2px solid #242422;outline-offset:1px}',
    '[aria-invalid=true]{border-color:#B3261E !important}',
    '.err{margin:6px 0 0;font-size:13px;line-height:18px;color:#B3261E}',
    '.row{margin-top:14px}',
    'fieldset{margin:0;padding:0;border:0;min-width:0}',
    '.chips{display:flex;gap:8px}',
    '.chip{position:relative;flex:1 1 0;min-width:0}',
    '.chip input{position:absolute;opacity:0;width:1px;height:1px;margin:0}',
    '.chip span{display:flex;align-items:center;justify-content:center;height:44px;padding:0 6px;border:1px solid #CFCAC3;border-radius:9px;background:#fff;font-size:15px;font-weight:600;color:#242422;cursor:pointer;user-select:none}',
    '.chip input:checked+span{background:#242422;border-color:#242422;color:#fff}',
    '.chip input:focus-visible+span{outline:2px solid #242422;outline-offset:2px}',
    '.btn{display:flex;align-items:center;justify-content:center;width:100%;height:50px;margin:16px 0 0;padding:0 16px;border:0;border-radius:6px;background:#0F0F0F;color:#fff;font:inherit;font-size:15px;line-height:20px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;cursor:pointer}',
    '.btn:hover{opacity:.9}',
    '.btn:focus-visible{outline:2px solid #0F0F0F;outline-offset:3px}',
    '.btn[disabled]{opacity:.5;cursor:default}',
    '.priv{display:flex;align-items:center;justify-content:center;gap:6px;margin:10px 0 0;font-size:12.5px;line-height:18px;color:#6F6B66;text-align:center}',
    '.priv svg{flex:0 0 auto;width:14px;height:14px}',
    '.res{text-align:center}',
    '.res:focus{outline:none}',
    '.eyebrow{margin:0;font-size:12px;line-height:16px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#6F6B66}',
    '.size{margin:4px 0 0;font-size:44px;line-height:48px;font-weight:700;color:#242422}',
    '.len{margin:2px 0 0;font-size:15px;line-height:21px;font-weight:600;color:#242422}',
    '.why{max-width:440px;margin:8px auto 0;font-size:14px;line-height:21px;color:#55534F}',
    '.pick{display:inline-block;margin:14px 0 0;padding:6px 12px;border-radius:999px;background:#fff;border:1px solid #E5E2DD;font-size:13px;line-height:18px;color:#34332F}',
    '.note{margin:10px 0 0;font-size:13px;line-height:19px;color:#34332F}',
    '.warn{color:#8A4B00}',
    '.offer{display:flex;align-items:flex-start;gap:8px;margin:14px 0 0;padding:10px 12px;border-radius:9px;background:#D4E1D7;color:#244317;font-size:13px;line-height:19px;text-align:left}',
    '.offer svg{flex:0 0 auto;width:16px;height:16px;margin-top:1px}',
    '.assure{margin:10px 0 0;font-size:13px;line-height:19px;color:#55534F}',
    '.contact{margin:12px 0 0;padding:10px 12px;border-radius:9px;background:#F6F5F2;font-size:13px;line-height:19px;color:#34332F}',
    '.contact a,.assure a{color:inherit}',
    '.again{margin:12px 0 0;padding:6px 4px;border:0;background:none;font:inherit;font-size:13px;line-height:18px;color:#34332F;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.again:focus-visible{outline:2px solid #242422;outline-offset:2px;border-radius:4px}',
    '.sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}',
    '@media (max-width:768px){:host{margin-top:16px}.card{padding:16px 14px 14px}.grid{gap:10px}.size{font-size:40px;line-height:44px}}'
  ].join('');

  var ICON_LOCK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="3" y="7" width="10" height="7" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.3"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
  var ICON_TAG = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8.6 1.5H14.5V7.4L7.4 14.5 1.5 8.6z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><circle cx="11.3" cy="4.7" r="1.1" fill="currentColor"/></svg>';
  var CONF = ['34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54'];

  function formHtml(cfg) {
    var opts = '<option value="">Weet ik niet</option>' + CONF.map(function (c) { return '<option value="' + c + '">' + c + '</option>'; }).join('') + '<option value="56">56 of groter</option>';
    var what = cfg.kind === 'tops' ? 'topjes en shirts' : 'broeken';
    return '<p class="h" id="t">Persoonlijk maatadvies</p>' +
      '<p class="lead" id="l">Vul je lengte en gewicht in, dan rekenen we je maat voor je uit. Dat kost je nog geen halve minuut.</p>' +
      '<div class="grid">' +
        '<div class="f"><label class="lab" for="h">Lengte</label><div class="box"><input type="text" id="h" inputmode="numeric" autocomplete="off" maxlength="5" placeholder="bijv. 168" aria-describedby="h-u h-e" aria-required="true"><span class="unit" id="h-u">cm</span></div><p class="err" id="h-e" hidden></p></div>' +
        '<div class="f"><label class="lab" for="w">Gewicht</label><div class="box"><input type="text" id="w" inputmode="decimal" autocomplete="off" maxlength="5" placeholder="bijv. 70" aria-describedby="w-u w-e" aria-required="true"><span class="unit" id="w-u">kg</span></div><p class="err" id="w-e" hidden></p></div>' +
      '</div>' +
      '<div class="row"><label class="lab" for="c">Welke maat draag je meestal in ' + what + '?</label><select id="c" autocomplete="off">' + opts + '</select></div>' +
      '<fieldset class="row"><legend>Hoe draag je het het liefst?</legend><div class="chips">' +
        ['strak', 'normaal', 'ruim'].map(function (v) { return '<label class="chip"><input type="radio" name="fit" value="' + v + '"' + (v === 'normaal' ? ' checked' : '') + '><span>' + v.charAt(0).toUpperCase() + v.slice(1) + '</span></label>'; }).join('') +
      '</div></fieldset>' +
      '<button type="submit" class="btn">Bekijk mijn maat</button>' +
      '<p class="priv">' + ICON_LOCK + '<span>Je gegevens worden niet opgeslagen.</span></p>';
  }

  function build(host) {
    if (host.__sa) return;
    var cfgEl = host.querySelector('script[type="application/json"]');
    var cfg = null;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = null; }
    if (!cfg || !chart(cfg).length) return;
    host.__sa = true;
    var sr;
    try { sr = host.attachShadow({ mode: 'open' }); } catch (e) { sr = null; }
    if (!sr) return; // very old browsers: the size table and help text stay as they are
    // The form is created as an element: parsing "<form>" via innerHTML inside a host that sits in the product form
    // (Agata, quick view) would drop the tag, because the HTML parser does not allow a form inside a form.
    sr.innerHTML = '<style>' + CSS + '</style><div class="card res" data-r tabindex="-1" hidden></div><p class="sr" aria-live="polite" data-live></p>';
    var formEl = doc.createElement('form');
    formEl.className = 'card';
    formEl.noValidate = true;
    formEl.setAttribute('data-f', '');
    formEl.innerHTML = formHtml(cfg);
    sr.insertBefore(formEl, sr.querySelector('[data-r]'));
    host.hidden = false;
    var $ = function (s) { return sr.querySelector(s); };
    var form = $('[data-f]'), res = $('[data-r]'), live = $('[data-live]');
    var hIn = $('#h'), wIn = $('#w'), cIn = $('#c');
    var current = null;

    function field(input, errEl, min, max, msg) {
      var raw = String(input.value).trim().replace(',', '.');
      var v = raw === '' ? NaN : Number(raw);
      var ok = !isNaN(v) && v >= min && v <= max;
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
      errEl.hidden = ok;
      errEl.textContent = ok ? '' : msg;
      return ok ? v : null;
    }
    function validate() {
      var h = field(hIn, $('#h-e'), 140, 200, 'Vul je lengte in centimeters in, tussen 140 en 200 cm.');
      var w = field(wIn, $('#w-e'), 40, 160, 'Vul je gewicht in kilo in, tussen 40 en 160 kg.');
      return { h: h, w: w };
    }
    [hIn, wIn].forEach(function (i) {
      i.addEventListener('input', function () { if (i.getAttribute('aria-invalid') === 'true') validate(); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = validate();
      if (v.h == null || v.w == null) { (v.h == null ? hIn : wIn).focus(); return; }
      var fitEl = form.querySelector('input[name="fit"]:checked');
      var input = { h: v.h, w: v.w, conf: cIn.value === '' ? null : Number(cIn.value), fit: fitEl ? fitEl.value : 'normaal' };
      var r = recommend(cfg, input);
      if (!r) return;
      current = { r: r, input: input };
      applyToPage(cfg, host, r);
      showResult();
    });

    function chosenVariant(r) {
      var opts = currentOptions(cfg, host);
      if (cfg.si >= 0) opts[cfg.si] = r.size;
      if (cfg.li >= 0 && r.length >= 0) opts[cfg.li] = cfg.lengths[r.length];
      for (var i = 0; i < cfg.variants.length; i++) {
        var v = cfg.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v[1][j] !== opts[j]) { ok = false; break; } }
        if (ok) return { id: v[0], options: v[1], available: v[2] };
      }
      return null;
    }

    function showResult() {
      var r = current.r, input = current.input;
      var v = chosenVariant(r);
      var len = (cfg.li >= 0 && r.length >= 0) ? cfg.lengths[r.length] : '';
      var why = input.conf == null
        ? 'Op basis van je lengte en gewicht. Twijfel je, dan raden we de grotere maat aan.'
        : 'Op basis van je lengte, gewicht en gebruikelijke maat. Twijfel je, dan raden we de grotere maat aan.';
      if (input.fit === 'ruim') why += ' Je draagt het graag ruim, daarom een maat groter.';
      var pick = '';
      if (v) {
        var parts = ['Maat ' + r.size];
        if (cfg.ci >= 0) parts.push(v.options[cfg.ci]);
        if (len) parts.push(len);
        pick = '<p class="pick">' + esc(parts.join(' · ')) + '</p>';
      }
      var html = '<p class="eyebrow" id="r-t">Jouw maat' + (cfg.name ? ' voor ' + esc(cfg.name) : '') + '</p>' +
        '<p class="size" aria-describedby="r-t">' + esc(r.size) + '</p>' +
        (len ? '<p class="len">Pijplengte ' + esc(len) + '</p>' : '') +
        '<p class="why">' + esc(why) + (len ? ' De pijplengte kiezen we bij je lengte.' : '') + '</p>' +
        pick;
      if (r.outside) {
        html += '<p class="contact">Je maten vallen buiten onze maattabel. We raden je daarom ' + esc(r.size) + ' aan, onze grootste maat. Twijfel je? Neem gerust contact met ons op via <a href="mailto:' + esc(cfg.email) + '">' + esc(cfg.email) + '</a>, dan denken we met je mee.</p>';
      }
      if (v && v.available) {
        html += '<button type="button" class="btn" data-add>In winkelmand</button>';
      } else {
        html += '<button type="button" class="btn" disabled>Uitverkocht</button>' +
          '<p class="note warn">Maat ' + esc(r.size) + (v && cfg.ci >= 0 ? ' is in ' + esc(v.options[cfg.ci]) : ' is op dit moment') + ' uitverkocht. Kies op de pagina een andere kleur.</p>';
      }
      html += '<p class="note" data-err role="alert" hidden></p>';
      // Per-product offer line from snippet alba-offer-line (theme HTML, empty = no offer).
      if (typeof cfg.offer === 'string' && cfg.offer) html += '<p class="offer">' + ICON_TAG + '<span>' + cfg.offer + '</span></p>';
      html += '<p class="assure">Past het toch niet? Je hebt 30 dagen geld-terug-garantie.</p>' +
        '<p class="priv">' + ICON_LOCK + '<span>Je gegevens worden niet opgeslagen.</span></p>' +
        '<button type="button" class="again" data-again>Gegevens aanpassen</button>';
      res.innerHTML = html;
      form.hidden = true;
      res.hidden = false;
      live.textContent = 'Ons advies: maat ' + r.size + (len ? ', pijplengte ' + len : '') + '.';
      try { res.focus({ preventScroll: true }); } catch (e) { res.focus(); }
      try { res.scrollIntoView({ block: 'nearest' }); } catch (e) {}
      var add = res.querySelector('[data-add]');
      if (add) add.addEventListener('click', function () { addToCart(v, add); });
      res.querySelector('[data-again]').addEventListener('click', function () {
        res.hidden = true; form.hidden = false; live.textContent = '';
        try { hIn.focus({ preventScroll: true }); } catch (e) { hIn.focus(); }
      });
    }

    function addToCart(v, btn) {
      var A = root.Alba || {};
      var err = res.querySelector('[data-err]');
      if (!A.addItems) return;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      err.hidden = true;
      A.addItems([{ id: v.id, quantity: 1 }])
        .then(function () {
          var dlg = host.closest('[data-pdpi-sg]');
          if (dlg && !dlg.hidden) { var c = dlg.querySelector('[data-pdpi-sg-close]'); if (c) c.click(); }
          if (A.closeAll) A.closeAll();
          return A.refreshCart ? A.refreshCart(true) : null;
        })
        .catch(function (e) {
          err.textContent = (e && e.message) || 'Toevoegen aan je winkelmand is niet gelukt. Probeer het opnieuw.';
          err.hidden = false;
        })
        .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
    }
  }

  /* The options the customer has chosen on the page: quick view / product page pickers, or the first piece of the chosen pack. */
  function pageRoot(cfg, host) {
    var r = host.closest('[data-pdpi]');
    if (r) return { type: 'pdpi', el: r };
    var p = qsa('[data-pdp]').filter(function (x) { return x.getAttribute('data-product-id') === String(cfg.pid); })[0];
    return p ? { type: 'pdp', el: p } : null;
  }
  function currentOptions(cfg, host) {
    var opts = (cfg.initial || []).slice();
    var pr = pageRoot(cfg, host);
    if (pr && pr.type === 'pdpi') {
      qsa('[data-option-index]', pr.el).forEach(function (w) {
        var i = parseInt(w.getAttribute('data-option-index'), 10), c = w.querySelector('input:checked');
        if (c && i < opts.length) opts[i] = c.value;
      });
    } else if (pr) {
      var sel = pr.el.querySelector('[data-bundle-option].is-selected .pdp-unit') || pr.el.querySelector('.pdp-unit');
      if (sel) qsa('[data-unit-opt]', sel).forEach(function (s) { var i = parseInt(s.getAttribute('data-unit-opt'), 10); if (i < opts.length) opts[i] = s.value; });
    }
    return opts;
  }
  /* Selects the advised size (and length) on the page as well, in the colours already chosen. */
  function applyToPage(cfg, host, r) {
    var pr = pageRoot(cfg, host);
    if (!pr) return;
    var set = [[cfg.si, r.size]];
    if (cfg.li >= 0 && r.length >= 0) set.push([cfg.li, cfg.lengths[r.length]]);
    set.forEach(function (p) {
      if (p[0] < 0) return;
      if (pr.type === 'pdpi') {
        var w = pr.el.querySelector('[data-option-index="' + p[0] + '"]');
        var input = w && qsa('input[data-option-input]', w).filter(function (i) { return i.value === p[1]; })[0];
        if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      } else {
        qsa('[data-bundle-option].is-selected .pdp-unit [data-unit-opt="' + p[0] + '"]', pr.el).forEach(function (s) {
          if (s.value !== p[1] && qsa('option', s).some(function (o) { return o.value === p[1]; })) { s.value = p[1]; s.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      }
    });
  }

  function scan() { qsa('[data-alba-sa]').forEach(build); }
  root.AlbaSA = { scan: scan, recommend: recommend };
  scan();
  if (root.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      (root.requestAnimationFrame || setTimeout)(function () { pending = false; scan(); });
    }).observe(doc.documentElement, { childList: true, subtree: true });
  }
})(typeof window !== 'undefined' ? window : this);
